class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.openModalOnLoad()
  }

  openModalOnLoad () {
    // check if url contains these query parameters '&=open-modal'
    const urlParams = window.location.search.substring(1).split('&=')

    urlParams.forEach(param => {
      if (param === 'open-modal') {
        const trigger = document.querySelector('[data-back-in-stock-external-el="trigger"]')

        if (trigger) {
          trigger.click()
        }
      }
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest('[data-back-in-stock-external-el="trigger"]')

    // This listener is bound to the whole document (see setupListeners), so
    // it runs on every click on the page, not just a real BIS trigger - bail
    // out before touching externalEls/els.title for anything else. Some
    // page templates (e.g. product-shade-finder.liquid) have a page-wide
    // data-back-in-stock-external-el="productTitle" element, so
    // this.externalEls.productTitle resolved truthy on every click
    // regardless of what was clicked, and this.els.title (scoped to
    // whichever <back-in-stock> instance is running) wasn't guaranteed to
    // exist for that click - confirmed live, 2026-08-19.
    if (!trigger) return

    let newVariantTitle = null

    if (this.externalEls.productTitle) {
      newVariantTitle = this.externalEls.productTitle.element.innerText
    }
    if (this.externalEls.variantTitle) {
      newVariantTitle = `${newVariantTitle} - ${this.externalEls.variantTitle.element.innerText}`
    }

    if (trigger.getAttribute('data-back-in-stock-product-title')) {
      newVariantTitle = trigger.getAttribute('data-back-in-stock-product-title')
    }

    if (trigger.getAttribute('data-back-in-stock-variant-title') && trigger.getAttribute('data-back-in-stock-variant-title') !== 'Default Title') {
      newVariantTitle = `${newVariantTitle} - ${trigger.getAttribute('data-back-in-stock-variant-title')}`
    }

    if (newVariantTitle != null) {
      this.els.title.element.innerText = `${newVariantTitle.toLowerCase()}`
    }

    // Retrieve all modal windows
    const modalWindows = document.querySelectorAll('back-in-stock')

    // Get the ID from the trigger
    const currentTriggerId = trigger.getAttribute('data-back-in-stock-item-trigger-id')

    modalWindows.forEach(modalWindow => {
      const modalWindowId = modalWindow.getAttribute('data-back-in-stock-item-trigger-id')

      // Show the modal if IDs match and hide others
      if (currentTriggerId === modalWindowId) {
        // Shared modals take their variant from the trigger, reset any previous success state
        if (trigger.dataset.backInStockVariantId) {
          const form = modalWindow.querySelector('[data-back-in-stock-el="form"]')
          const content = modalWindow.querySelector('[data-product-bis-el="content"]')
          const success = modalWindow.querySelector('[data-product-bis-el="success"]')

          if (form) form.dataset.variantId = trigger.dataset.backInStockVariantId
          content?.setAttribute('aria-hidden', 'false')
          success?.setAttribute('aria-hidden', 'true')
        }

        modalWindow.setAttribute('aria-hidden', 'false')
      } else {
        modalWindow.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
